<template>
  <div class="project-items-wrapper flex w-full">
    <div class="px-4 py-3 w-auto min-w-48">
      <div class="text-sm text-gray-600 pb-2">
        {{ title || "&nbsp;" }}
      </div>
      <template v-for="(project, index) in projects" :key="index">
        <div class="p-2.5 hover:bg-gray-100 hover:text-blue-500 cursor-pointer flex items-center justify-between"
             @click="selectProject(project)"
             @mouseover="expandProject(project)">
          <div class="flex-1 min-w-0 truncate">
            {{ project.name }}
          </div>
          <va-icon
            v-if="project.children?.length"
            name="chevron_right" 
            class="transition-transform flex-shrink-0 ml-2"
          />
        </div>
      </template>
    </div>
    
    <template v-if="expandedProject && expandedProject?.children?.length">
      <ProjectSelector
        :projects="expandedProject.children"
        :title="''"
        @select="handleChildSelect"
      />
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({
  projects: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['select'])
const selectedProject = ref(null)
const expandedProject = ref(null)

const selectProject = (project) => {
  selectedProject.value = project
  emit('select', project)
}

const expandProject = (project) => {
  expandedProject.value = project
}

const handleChildSelect = (project) => {
  emit('select', project)
}
</script>

<style scoped>
.project-items-wrapper {
  max-width: 800px; /* 防止无限嵌套时宽度过大 */
  overflow-x: auto;
}
</style> 